import grid from '../components/grid';
import helpers from '../helpers';
import lottieText from '../components/animationText';
import vars from '../helpers';

function fullAnimation(isModal) {
	if (!helpers.isMobile()) {
		vars.$body.style.pointerEvents = 'none';
	}

	const tl = gsap.timeline({
		onStart() {
			document.querySelector('.home').classList.remove('is-hidden');
			document.querySelector('.header').classList.remove('is-hidden');
			document.querySelector('.footer').classList.remove('is-hidden');

			if (!helpers.isMobile()) {
				setTimeout(() => {
					const x = -1 * (document.querySelector('.grid').offsetWidth / 2 - window.innerWidth / 2);
					grid.setGridPosition(x);
				}, 0);
			}
		},
	})
		.from('.grid__title', {
			scale: 0.8,
			autoAlpha: 0,
			clearProps: 'all',
			duration: 1,
			delay: 0.4,
		})
		.from('.grid__subtitle', {
			autoAlpha: 0,
			clearProps: 'all',
			duration: 1,
			onStart: () => {
				lottieText.init();
			},
		})
		.from('.grid__description', {
			y: 100,
			autoAlpha: 0,
			clearProps: 'all',
			duration: 1,
		});

	if (!helpers.isMobile()) {
		tl.from('.grid-item', {
			scale: 0,
			autoAlpha: 0,
			duration: 2,
			ease: 'power2.inOut',
			stagger: {
				grid: 'auto',
				from: 'random',
				amount: 2,
				ease: 'power1.in',
			},
			clearProps: 'all',
			onComplete() {
				grid.init(isModal);
				vars.$body.style.pointerEvents = 'all';
			},
		})
			.from('.header__logo', {
				scale: 0,
				autoAlpha: 0,
				duration: 2,
				stagger: 1,
				clearProps: 'all',
			}, '-=4')
			.from('.header__joint', {
				autoAlpha: 0,
				duration: 1,
				delay: '-=1',
				clearProps: 'all',
			});
	} else {
		tl.from(['.header__logo', '.header__joint'], {
			autoAlpha: 0,
			duration: 1,
			delay: '-=1',
			clearProps: 'all',
		}).from('.grid__container', {
			x: '100%',
			autoAlpha: 0,
			duration: 1,
			clearProps: 'all',
			onComplete() {
				grid.init(isModal);
			},
		});
	}

	tl.from('.footer', {
		y: 50,
		autoAlpha: 0,
		duration: 1,
		delay: '-=0.3',
		clearProps: 'all',
	}).from('.grid__tooltip', {
		autoAlpha: 0,
		clearProps: 'all',
	});
}

function partAnimation(isModal) {
	gsap.timeline({
		onStart() {
			document.querySelector('.home').classList.remove('is-hidden');
			document.querySelector('.header').classList.remove('is-hidden');
			document.querySelector('.footer').classList.remove('is-hidden');

			if (!helpers.isMobile()) {
				setTimeout(() => {
					const x = -1 * (document.querySelector('.grid').offsetWidth / 2 - window.innerWidth / 2);
					grid.setGridPosition(x);
				}, 0);
			}
		},
		onComplete() {
			grid.init(isModal);
		},
	})
		.from('.header', {
			y: -100,
			autoAlpha: 0,
			duration: 1,
			delay: 0.5,
			clearProps: 'all',
		})
		.from('.footer', {
			y: 50,
			autoAlpha: 0,
			duration: 1,
			delay: '-=0.5',
			clearProps: 'all',
		})
		.from('.grid', {
			duration: 1,
			autoAlpha: 0,
			delay: '-=0.5',
		})
		.from('.grid__subtitle', {
			autoAlpha: 0,
			clearProps: 'all',
			duration: 1,
			delay: '-=1',
			onStart: () => {
				lottieText.init();
			},
		});
}

export default {
	fullAnimation,
	partAnimation,
};
